import { createSelector } from 'reselect';

import { createParameterSelector, type OperationStatus } from '@pressreader/appstore';
import type { ArticleCollections } from '@pressreader/social-types';

import { getModuleState } from '../reducers';

const getState = createSelector(getModuleState, state => state.articleCollections);

const getStateArticleCollections = createSelector(getState, state => state.articleCollections);

const selectArticleId = createParameterSelector<'articleId', string>('articleId');
const selectArticleCollectionsStateById = createSelector(
    getStateArticleCollections,
    selectArticleId,
    (stateArticleCollections, articleId) => stateArticleCollections[articleId],
);

const selectArticleCollectionsStatusByArticleId = createSelector(
    selectArticleCollectionsStateById,
    (stateArticleCollections): OperationStatus | undefined => stateArticleCollections?.status,
);
const selectArticleCollectionsByArticleId = createSelector(
    selectArticleCollectionsStateById,
    (stateArticleCollections): ArticleCollections | undefined => stateArticleCollections?.collections,
);

export { selectArticleCollectionsStatusByArticleId, selectArticleCollectionsByArticleId };
